import React, {useContext, useEffect, useState} from "react";
import styled from "styled-components";
import {BiLogOut} from 'react-icons/bi';
import {AuthContext} from "../../context/AuthContext";
import CustomAvatar from "./CustomAvatar";
import {useNavigate} from "react-router-dom";

const TopButtonUser = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
`

const CornerInfo = () => {

  const {user} = useContext(AuthContext)
  const [name, setName] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    if (user) {
      setName(user?.name.slice(0, 3))
    }
  }, [user])

  return (
    <TopButtonUser>
      <CustomAvatar name={name}>
        <hr style={{margin:0}}/>
        <div onClick={() => navigate('/logout')} style={{display:'flex',flexDirection:'row',gap:'8px', alignItems:'center',padding:'12px 0'}}>
          <BiLogOut size={20}/>
          <span>Salir</span>
        </div>
      </CustomAvatar>
    </TopButtonUser>
  )
}

export default CornerInfo
